interface UserAvatarProps {
  className?: string;
  name: string;
  src?: string | null | undefined;
  imageAlt?: string;
}

export function UserAvatar({ className = '', imageAlt, name, src }: UserAvatarProps) {
  const classes = ['user-avatar', className].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      <span aria-hidden="true">{name.slice(0, 1).toUpperCase() || 'U'}</span>
      {src ? (
        <img
          alt={imageAlt ?? `${name} profile picture`}
          key={src}
          onError={(event) => { event.currentTarget.hidden = true; }}
          src={src}
        />
      ) : null}
    </span>
  );
}
